<template>
  <v-radio-group
    :value="selectedOrganization"
    class="mt-2"
    @change="$emit('change', $event)"
  >
    <v-radio
      v-for="(n, index) in organizationsForRadio"
      :key="index"
      :label="`${n.text} (${n.value})`"
      :value="n.value"
    />
  </v-radio-group>
</template>

<script>
export default {
  props: {
    selectedOrganization: {
      type: String,
      default: () => '',
    },

    organizations: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    organizationsForRadio() {
      return this.organizations.map(item => ({
        text: item.organization.name,
        value: item.organization.businessId,
      }));
    },
  },
};
</script>
